import type { ReactNode } from "react"
import { ErrorBoundary } from "@/components/error-boundary"
import { Button } from "@/components/ui/button"

export function PanelErrorFallback({
	title,
	onRetry,
}: {
	title: string
	onRetry: () => void
}) {
	return (
		<section
			role="alert"
			className="rounded-2xl border border-border bg-card p-6 font-inter shadow-card"
		>
			<div
				className="mb-4 flex size-9 items-center justify-center rounded-full bg-amber-100 text-body font-semibold text-amber-800"
				aria-hidden="true"
			>
				!
			</div>
			<h2 className="text-section-title font-semibold text-heading">
				{title} couldn’t be displayed
			</h2>
			<p className="mt-2 max-w-md text-body text-muted-foreground">
				Something went wrong displaying this section. Try again, or reload the
				page if it keeps happening.
			</p>
			<div className="mt-5 flex flex-wrap gap-2">
				<Button size="sm" onClick={onRetry}>
					Try again
				</Button>
				<Button
					size="sm"
					variant="secondary"
					onClick={() => window.location.reload()}
				>
					Reload page
				</Button>
			</div>
		</section>
	)
}

export function PanelErrorBoundary({
	title,
	children,
	resetKey,
}: {
	title: string
	children: ReactNode
	resetKey?: string | number
}) {
	return (
		<ErrorBoundary
			{...(resetKey === undefined ? {} : { resetKey })}
			fallback={(reset) => <PanelErrorFallback title={title} onRetry={reset} />}
		>
			{children}
		</ErrorBoundary>
	)
}
